const TermsAndConditions = {
    ACCEPT: 'Accept',
    DECLINE: 'Decline',
};

export default TermsAndConditions;